import t from"./List/zh-CN.js";import e from"./List/en-US.js";export default{"en-US":e,"zh-CN":t};
